var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104.979,
    height: 125.422,
    viewBox: "0 0 104.979 125.422",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 9.821,
    y1: 0.578,
    x2: -1.115,
    y2: 0.486,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f1593a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec2181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 7.716,
    y1: 0.56,
    x2: -3.2,
    y2: 0.468,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.919,
    y1: 1.162,
    x2: 0.049,
    y2: -0.213,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#f1593a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#d61a7d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1.279,
    y1: 0.502,
    x2: -0.018,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 5.609,
    y1: 0.542,
    x2: -5.308,
    y2: 0.45,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M43.083,143.24a4.836,4.836,0,1,1-1.411-3.429A4.841,4.841,0,0,1,43.083,143.24Z",
    transform: "translate(-23.676 -98.101)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M112.64,143.24a4.847,4.847,0,1,1-1.42-3.43,4.85,4.85,0,0,1,1.42,3.43Z",
    transform: "translate(-72.971 -98.101)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 55.271,
    height: 35.157,
    transform: "translate(0 90.265)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M43.083,143.24a4.836,4.836,0,1,1-1.411-3.429A4.841,4.841,0,0,1,43.083,143.24Z",
    transform: "translate(-23.676 -98.101)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M112.64,143.24a4.847,4.847,0,1,1-1.42-3.43,4.85,4.85,0,0,1,1.42,3.43Z",
    transform: "translate(-72.971 -98.101)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M104.979,45.14A45.125,45.125,0,0,1,59.853,90.265H0v-28.4H57.644a16.731,16.731,0,1,0,0-33.461H0V0H59.853a45.125,45.125,0,0,1,45.125,45.14Z",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M43.083,143.24a4.836,4.836,0,1,1-1.411-3.429A4.841,4.841,0,0,1,43.083,143.24Z",
    transform: "translate(-23.676 -98.101)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M112.64,143.24a4.847,4.847,0,1,1-1.42-3.43,4.85,4.85,0,0,1,1.42,3.43Z",
    transform: "translate(-72.971 -98.101)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M69.472,102.46a16.752,16.752,0,0,0-11.829-4.9H0v33.46H57.644a16.731,16.731,0,0,0,11.837-28.56Zm-54.9,16.673a4.844,4.844,0,1,1,4.836-4.836,4.844,4.844,0,0,1-4.836,4.836Zm20.248,0a4.844,4.844,0,1,1,4.85-4.836,4.844,4.844,0,0,1-4.85,4.836Zm20.458,0a4.844,4.844,0,1,1,4.836-4.836,4.844,4.844,0,0,1-4.836,4.836Z",
    transform: "translate(0 -69.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M43.083,143.24a4.836,4.836,0,1,1-1.411-3.429A4.841,4.841,0,0,1,43.083,143.24Z",
    transform: "translate(-23.676 -98.101)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M112.64,143.24a4.847,4.847,0,1,1-1.42-3.43,4.85,4.85,0,0,1,1.42,3.43Z",
    transform: "translate(-72.971 -98.101)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M112.64,143.24a4.847,4.847,0,1,1-1.42-3.43,4.85,4.85,0,0,1,1.42,3.43Z",
    transform: "translate(-72.971 -98.101)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M43.083,143.24a4.836,4.836,0,1,1-1.411-3.429A4.841,4.841,0,0,1,43.083,143.24Z",
    transform: "translate(-23.676 -98.101)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M182.86,143.24a4.836,4.836,0,1,1-1.411-3.429A4.85,4.85,0,0,1,182.86,143.24Z",
    transform: "translate(-122.748 -98.1)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M57.635,212.49,0,220.281V212.49Z",
    transform: "translate(0 -150.628)",
    fill: "#191919",
    opacity: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8767e04deb6bc048a9646abb8aa09ca9.svg";
export { ForwardRef as ReactComponent };